import React from 'react';

export const NoAccountIcon = () => {
    return (
        <svg
            width='66'
            height='66'
            viewBox='0 0 66 66'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect x='5' y='5' width='56' height='56' rx='28' fill='#F2F4F7' />
            <rect
                x='5'
                y='5'
                width='56'
                height='56'
                rx='28'
                stroke='#F9FAFB'
                strokeWidth='10'
            />
            <path
                d='M35.6386 37.0115H29.8053'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M32.722 34.1644V39.9977'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M33.77 21.9378L33.735 22.0195L30.3516 29.8712H27.0266C26.2333 29.8712 25.475 30.0345 24.7866 30.3262L26.8283 25.4495L26.875 25.3328L26.9566 25.1462C26.98 25.0762 27.0033 25.0062 27.0383 24.9478C28.5666 21.4128 30.2933 20.6078 33.77 21.9378Z'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M40.0584 30.1045C39.5334 29.9412 38.9734 29.8712 38.4134 29.8712H30.3517L33.735 22.0195L33.77 21.9378C33.945 21.9962 34.1084 22.0778 34.2834 22.1478L36.8617 23.2328C38.2967 23.8278 39.3 24.4462 39.9067 25.1928C40.0234 25.3328 40.1167 25.4612 40.1984 25.6128C40.3034 25.7762 40.385 25.9395 40.4317 26.1145C40.4784 26.2195 40.5134 26.3245 40.5367 26.4178C40.8517 27.3978 40.665 28.5995 40.0584 30.1045Z'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M44.1087 35.5648V37.8398C44.1087 38.0731 44.097 38.3064 44.0854 38.5398C43.8637 42.6114 41.5887 44.6648 37.272 44.6648H28.172C27.892 44.6648 27.612 44.6414 27.3437 44.6064C23.6337 44.3614 21.6504 42.3781 21.4054 38.6681C21.3704 38.3998 21.347 38.1198 21.347 37.8398V35.5648C21.347 33.2198 22.7704 31.2014 24.8004 30.3264C25.5004 30.0348 26.247 29.8714 27.0404 29.8714H38.427C38.9987 29.8714 39.5587 29.9531 40.072 30.1048C42.3937 30.8164 44.1087 32.9864 44.1087 35.5648Z'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M26.8284 25.4495L24.7867 30.3262C22.7567 31.2012 21.3334 33.2195 21.3334 35.5645V32.1462C21.3334 28.8328 23.69 26.0678 26.8284 25.4495Z'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M44.105 32.1456V35.5639C44.105 32.9973 42.4017 30.8156 40.0684 30.1156C40.675 28.5989 40.85 27.4089 40.5584 26.4173C40.535 26.3123 40.5 26.2073 40.4534 26.1139C42.6234 27.2339 44.105 29.5323 44.105 32.1456Z'
                stroke='#292D32'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};
